/**
 * Configuración de voces por modo y acento
 * 
 * Este archivo centraliza todas las configuraciones de voces para los diferentes
 * modos de práctica (Galia, Tommy, etc.) y acentos (Francia, Canadá, Australia, Bélgica).
 * 
 * Para cambiar una voz, simplemente modifica el valor de 'voice' en la combinación deseada.
 * El formato de voz debe ser compatible con Azure Cognitive Services (ej: 'fr-FR-Chirp3-HD-Achernar')
 */

import { PracticeMode, AccentType } from '../types';

export interface VoiceConfig {
  voice: string;
  language: string;
}

// Configuración de voces: [modo][acento] → { voice, language }
export const VOICE_CONFIG: Record<PracticeMode, Record<AccentType, VoiceConfig>> = {
  // Modo Conversacional - Galia
  'conversacional': {
    'Francia': {
      voice: 'fr-FR-Chirp3-HD-Achernar', // TODO: Cambiar voz para Galia - Francia
      language: 'fr-FR'
    },
    'Canadá': {
      voice: 'fr-CA-Chirp3-HD-Achernar', // TODO: Cambiar voz para Galia - Canadá
      language: 'fr-CA'
    },
    'Australia': {
      voice: 'fr-FR-Chirp3-HD-Achernar', // TODO: Cambiar voz para Galia - Australia
      language: 'fr-FR'
    },
    'Bélgica': {
      voice: 'fr-BE-CharlineNeural',
      language: 'fr-BE'
    }
  },

  // Modo Estudio - Tommy
  'estudio': {
    'Francia': {
      voice: 'fr-FR-Chirp3-HD-Achernar', // TODO: Cambiar voz para Tommy - Francia
      language: 'fr-FR'
    },
    'Canadá': {
      voice: 'fr-CA-Chirp3-HD-Achernar', // TODO: Cambiar voz para Tommy - Canadá
      language: 'fr-CA'
    },
    'Australia': {
      voice: 'fr-FR-Chirp3-HD-Achernar', // TODO: Cambiar voz para Tommy - Australia
      language: 'fr-FR'
    },
    'Bélgica': {
      voice: 'fr-BE-CharlineNeural',
      language: 'fr-BE'
    }
  },

  // Modo Examen - Galia Examen
  'examen': {
    'Francia': {
      voice: 'fr-FR-Chirp3-HD-Achernar', // TODO: Cambiar voz para Galia Examen - Francia
      language: 'fr-FR'
    },
    'Canadá': {
      voice: 'fr-CA-Chirp3-HD-Achernar', // TODO: Cambiar voz para Galia Examen - Canadá
      language: 'fr-CA'
    },
    'Australia': {
      voice: 'fr-FR-Chirp3-HD-Achernar', // TODO: Cambiar voz para Galia Examen - Australia
      language: 'fr-FR'
    },
    'Bélgica': {
      voice: 'fr-BE-CharlineNeural',
      language: 'fr-BE'
    }
  },

  // Modo Actividades Docente - Galia Actividades
  'actividades-docente': {
    'Francia': {
      voice: 'fr-FR-Chirp3-HD-Achernar', // TODO: Cambiar voz para Galia Actividades Docente - Francia
      language: 'fr-FR'
    },
    'Canadá': {
      voice: 'fr-CA-Chirp3-HD-Achernar', // TODO: Cambiar voz para Galia Actividades Docente - Canadá
      language: 'fr-CA'
    },
    'Australia': {
      voice: 'fr-FR-Chirp3-HD-Achernar', // TODO: Cambiar voz para Galia Actividades Docente - Australia
      language: 'fr-FR'
    },
    'Bélgica': {
      voice: 'fr-BE-CharlineNeural',
      language: 'fr-BE'
    }
  },

  // Modo Actividades Estudiante - Galia Actividades
  'actividades-estudiante': {
    'Francia': {
      voice: 'fr-FR-Chirp3-HD-Achernar', // TODO: Cambiar voz para Galia Actividades Estudiante - Francia
      language: 'fr-FR'
    },
    'Canadá': {
      voice: 'fr-CA-Chirp3-HD-Achernar', // TODO: Cambiar voz para Galia Actividades Estudiante - Canadá
      language: 'fr-CA'
    },
    'Australia': {
      voice: 'fr-FR-Chirp3-HD-Achernar', // TODO: Cambiar voz para Galia Actividades Estudiante - Australia
      language: 'fr-FR'
    },
    'Bélgica': {
      voice: 'fr-BE-CharlineNeural',
      language: 'fr-BE'
    }
  }
};

/**
 * Obtiene la configuración de voz para un modo y acento específicos
 * 
 * @param mode - Modo de práctica (conversacional, estudio, examen, etc.)
 * @param accent - Acento seleccionado (Francia, Canadá, Australia, Bélgica)
 * @returns Configuración de voz con voice y language, o valores por defecto si no se encuentra
 */
export function getVoiceConfig(mode: PracticeMode, accent: AccentType): VoiceConfig {
  // Verificar que la configuración existe
  if (VOICE_CONFIG[mode] && VOICE_CONFIG[mode][accent]) {
    return VOICE_CONFIG[mode][accent];
  }

  // Valores por defecto si no se encuentra la combinación
  console.warn(`[VoiceConfig] No se encontró configuración para modo "${mode}" y acento "${accent}", usando valores por defecto`);
  return {
    voice: 'fr-FR-Chirp3-HD-Achernar',
    language: 'fr-FR'
  };
}


